var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-spin',{attrs:{"type":"loading","spin":_vm.loading,"tip":"加载中"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }